import React from "react"
import PropTypes from "prop-types"

import Typograph from "../../../../../components/Typograph"
import ButtonFixedVoice from "../../ButtonFixedVoice"

import styles from "../styles.css"

const ExportDataModal = ({ action, onDownload }) => {
  return (
    <div>
      <Typograph htmlTag="h1" size="medium" color="outer_space" weight="bold">
        {action}
      </Typograph>
      <div className={styles.space_title}>
        <Typograph
          htmlTag="h1"
          size="medium"
          color="outer_space"
          weight="regular"
        >
          Deseja exportar os dados dos clientes?
        </Typograph>
      </div>
      <div className={styles.space}>
        <div className={styles.container_buttons_export}>
          <ButtonFixedVoice name={"Confirmar"} onAction={() => onDownload()} />
        </div>
      </div>
    </div>
  )
}
ExportDataModal.propTypes = {
  action: PropTypes.string,
  onDownload: PropTypes.func
}
export default ExportDataModal



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/ActionForm/ExportDataModal/index.js